import { en } from "./en";
import { pt } from "./pt";

export const translations = {
  en,
  pt,
};

// Utility function to interpolate variables in translation strings
export const interpolate = (text, variables = {}) => {
  return text.replace(/\{(\w+)\}/g, (match, key) => {
    if (key === "plural") {
      // Handle pluralization
      const count = variables.count || 0;
      return count === 1 ? "" : "s";
    }
    return variables[key] !== undefined ? variables[key] : match;
  });
};

// Get translation with interpolation
export const t = (key, language = "en", variables = {}) => {
  const translation =
    translations[language]?.[key] || translations.en[key] || key;
  return interpolate(translation, variables);
};

export default translations;
